export default "__VITE_ASSET__Cvjx1Erk__"